import { HandleGoalsArgs } from './types'

export const handleToggleGoals = ({ existingGoals, goal }: HandleGoalsArgs) => {
  if (!goal) return existingGoals

  // Filter out the goal if it's already been added to the list of goals to create
  const foundGoalIndex = existingGoals.map((g) => g.label).indexOf(goal.label)
  if (foundGoalIndex > -1) {
    return existingGoals.filter((g) => g.label !== goal.label)
  }

  // Otherwise add the goal to the list of goals to create
  return [...existingGoals, goal]
}
